import React, { useState, useContext, useEffect } from 'react';
import { MyContext } from '../../../../../Context/MyContext';
import API from '../../../../../Api/api';
import { trackActivity, propertyActivityLabel } from '../../../../../utils/userActivity';
import { toast } from 'react-toastify';
import './EnquiryModal.css';

import ReactDOM from 'react-dom';



const EnquiryModal = ({ property, onClose }) => {
  const [isOpening, setIsOpening] = useState(false);

  // 1. Trigger the 'fade-in' class after the component mounts
  useEffect(() => {
    const timer = setTimeout(() => setIsOpening(true), 10);
    return () => clearTimeout(timer);
  }, []);

  // 2. Trigger close animation and wait
  const handleClose = () => {
    setIsOpening(false); // Triggers the CSS transition
    setTimeout(() => onClose(), 300); // Only remove from DOM after animation
  };

const [isMobile, setIsMobile] = useState(
  window.matchMedia("(max-width: 768px)").matches
);

useEffect(() => {
  const media = window.matchMedia("(max-width: 768px)");

  const listener = (e) => setIsMobile(e.matches);

  media.addEventListener("change", listener);

  return () => media.removeEventListener("change", listener);
}, []);
  
  const { user } = useContext(MyContext);

  const [form, setForm] = useState({
    name:    user?.name || user?.user_name || '',
    phone:   user?.phone ||  user?.user_phone || '',
    email:   user?.email || '',
    message: `Hi, I'm interested in this property. Please contact me.`,
  });
  const [loading, setLoading] = useState(false);
  const [sent,    setSent]    = useState(false);
  const [errors,  setErrors]  = useState({});

  const onChange = (field, val) => {
    setForm(p => ({ ...p, [field]: val }));
    if (errors[field]) setErrors(p => ({ ...p, [field]: '' }));
  };

  const validate = () => {
    const errs = {};
    if (!form.name.trim())  errs.name  = 'Name is required';
    if (!form.phone.trim()) errs.phone = 'Phone is required';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      await API.post('/enquiry', {
        property_id: property?.id || null,
        user_id:     user?.id     || null,
        name:        form.name.trim(),
        phone:       form.phone.trim(),
        email:       form.email.trim(),
        message:     form.message,
      });
      if (property?.id) {
        await trackActivity({
          type: 'enquiry',
          label: propertyActivityLabel(property, 'Enquiry submitted'),
          url: `/property/${property.id}`,
          property_id: property.id,
        }, user);
      }
      setSent(true);
      toast.success('Enquiry sent!');
      setTimeout(() => onClose(), 2000);
    } catch (err) {
      const msg = err.response?.data?.error || 'Failed to send enquiry. Please try again.';
      toast.error(msg);
      console.error('Enquiry error:', err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

return (
    <div 
      className={`enquiry-overlay ${isOpening ? 'fade-in' : 'fade-out'}`} 
      onClick={handleClose}
    >
      <div 
        className={!isMobile ? "enquiry-modal" : "enquiry-sheet"} 
        onClick={e => e.stopPropagation()}
      >
        <div className="enquiry-header">
          <br />
          <div className="enquiry-header-left">
            <div className="enquiry-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
            </div>
            <div>
              <h2 className="enquiry-title">Send Enquiry</h2>
              {property && (
                <p className="enquiry-property-name">
                  {property.location || property.address || `Property #${property.property_id}`}
                </p>
              )}
            </div>
          </div>
          {/* <button className="enquiry-close" onClick={onClose} type="button">×</button> */}
        </div>

        {sent ? (
          <div className="enquiry-success">
            <div className="enquiry-success-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="48" height="48">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="9 12 11.5 14.5 15 10"/>
              </svg>
            </div>
            <h3>Enquiry Sent!</h3>
            <p>We'll contact you shortly regarding this property.</p>
          </div>
        ) : (
          <form className="enquiry-form" onSubmit={handleSubmit} noValidate>
            <div className="enquiry-field">
              <label>Your Name <span className="req">*</span></label>
              <input type="text" value={form.name} onChange={e => onChange('name', e.target.value)} placeholder="Enter your name"/>
              {errors.name && <span className="eq-error">{errors.name}</span>}
            </div>

            <div className="enquiry-row">
              <div className="enquiry-field">
                <label>Phone <span className="req">*</span></label>
                <input type="tel" value={form.phone} onChange={e => onChange('phone', e.target.value)} placeholder="+91 00000 00000"/>
                {errors.phone && <span className="eq-error">{errors.phone}</span>}
              </div>
              <div className="enquiry-field">
                <label>Email</label>
                <input type="email" value={form.email} onChange={e => onChange('email', e.target.value)} placeholder="you@email.com"/>
              </div>
            </div>

            <div className="enquiry-field">
              <label>Message</label>
              <textarea value={form.message} onChange={e => onChange('message', e.target.value)} rows={3}/>
            </div>

            <div className="enquiry-footer">
              <button type="button" className="enquiry-cancel-btn" onClick={onClose}>Cancel</button>
              <button type="submit" className="enquiry-submit-btn" disabled={loading}>
                {loading ? <><span className="enquiry-spinner"/> Sending…</> : <>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="15" height="15">
                    <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
                  </svg>
                  Send Enquiry
                </>}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default EnquiryModal;